import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import Loadable from '@components/Loadable/Loadable';
import AuthenticationRoutes from './AuthenticationRoutes';
import AppRoutes from './AppRoutes';

const WhatsNewPage = Loadable(
  lazy(() => import('@pages/WhatsNewPage/WhatsNewPage'))
);

// Public, no sign-in: outside both AppRoutes (ProtectedRoute) and
// AuthenticationRoutes (AuthLayout sends a signed-in user to home).
const PublicRoutes = {
  path: '/whats-new',
  element: <WhatsNewPage />,
};

const router = createBrowserRouter(
  [PublicRoutes, AppRoutes, AuthenticationRoutes],
  {
    basename: import.meta.env.VITE_APP_BASE_NAME,
  }
);

export default router;
